import { anims } from '../engine/anims-sidecar'
import { IMachine } from './machines'
import { machines } from './machines-sidecar'
import { machinesAnims } from './machinesAnims-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'airlock2')
}

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  open(obj, true, true)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  anims.update(obj.parts[0].anim)
  anims.update(obj.parts[1].anim)
  anims.update(obj.parts[2].anim)
  anims.update(obj.parts[3].anim)
}

export function isInTransition(obj: IMachine) {
  ensure(obj)
  return obj.parts[0].anim.playing || obj.parts[2].anim.playing
}

export function open(obj: IMachine, isOpen: boolean, force: boolean = false) {
  ensure(obj)
  if (obj.isOpen !== isOpen || force) {
    obj.isOpen = isOpen
    obj.progress = 0
    if (isOpen) {
      anims.play(obj.parts[0].anim, machinesAnims.all.doorAirlockTopOpen)
      anims.play(obj.parts[1].anim, machinesAnims.all.doorAirlockBottomOpen)
      anims.play(obj.parts[2].anim, machinesAnims.all.doorAirlockTopClose)
      anims.play(obj.parts[3].anim, machinesAnims.all.doorAirlockBottomClose)
    } else {
      anims.play(obj.parts[0].anim, machinesAnims.all.doorAirlockTopClose)
      anims.play(obj.parts[1].anim, machinesAnims.all.doorAirlockBottomClose)
      anims.play(obj.parts[2].anim, machinesAnims.all.doorAirlockTopOpen)
      anims.play(obj.parts[3].anim, machinesAnims.all.doorAirlockBottomOpen)
    }
  }

  // spriteMap obj.parts[0].image
}
